/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { APPLICATION_VIEW_MASTER, APPLICATION_VIEW_OFFICE } from '@gh/builder-shared-data';
import { createRoute } from '@gh/builder-shared';
import { SubOfficeDetailsComponent } from './components/sub-office-details/sub-office-details.component';
import { SubOfficeListComponent } from './components/sub-office-list/sub-office-list.component';
import { SubOfficeDetailsBusinessService } from './resources/sub-office-details-business.service';
import { SubOfficeListBusinessService } from './resources/sub-office-list-business.service';

const routes = [
  createRoute({
    component: SubOfficeListComponent,
    path: '',
    pathMatch: 'full',
    init: SubOfficeListBusinessService,
    auth: {
      applicationView: [ APPLICATION_VIEW_MASTER, APPLICATION_VIEW_OFFICE],
    },
  }),
  createRoute({
    component: SubOfficeDetailsComponent,
    path: 'new',
    pathMatch: 'full',
    init: SubOfficeDetailsBusinessService,
    auth: {
      applicationView: [ APPLICATION_VIEW_MASTER, APPLICATION_VIEW_OFFICE],
    },
    leave: true,
  }),
  createRoute({
    component: SubOfficeDetailsComponent,
    path: ':officeId',
    pathMatch: 'full',
    init: SubOfficeDetailsBusinessService,
    auth: {
      applicationView: [ APPLICATION_VIEW_MASTER, APPLICATION_VIEW_OFFICE],
    },
    leave: true,
  }),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BuilderSetupSubOfficesRoutingModule {
}
